import { $http } from '@/utils';

/**
 * @namespace Service
 * @class Product
 * @exports Service/Product/Issue
 * @description API Product Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class ProductIssue {
	/**
	 * @static @name post
	 * @description Add a new product issue
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static post(payload) {
		return $http.post(`product/issue`, payload);
	}
}
